import { useRef, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";
import { captureException } from "@sentry/nextjs";

export const FooterDisclaimer = () => {
  const ref = useRef<HTMLParagraphElement>(null);
  const hasTrackedVisibility = useRef(false);
  const analytics = useMixpanel();

  useEffect(() => {
    if (typeof window === "undefined" || !ref.current) {
      return;
    }

    const element = ref.current;

    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasTrackedVisibility.current) {
            void analytics.track("Footer - Site Disclaimer - Scrolled Into View");
            hasTrackedVisibility.current = true;
          }
        },
        {
          threshold: 0.5,
        }
      );

      observer.observe(element);

      return () => {
        observer.unobserve(element);
      };
    } catch (error) {
      captureException(error);
    }
  }, [analytics]);

  return (
    <DisclaimerText ref={ref}>
      Disclaimer: Dreambound Inc., a Delaware C-corporation, owns and operates Dreambound™ (the
      &quot;Site&quot;). The Site is a platform to help people explore new careers and higher
      education offerings. Partnered institutions and other service providers you see on our
      platform pay to advertise, and this payment may influence their placement and visibility on
      our site. While we connect you with educational and other service offerings, we do not endorse
      or recommend any particular institution or service provider. By viewing or responding to
      information on our platform, you are not obligated to apply to, enroll in, or purchase any
      program or service.
    </DisclaimerText>
  );
};

const DisclaimerText = styled("span")`
  display: block;
  font-size: 0.7rem;
  line-height: 1.2;
  color: rgba(4, 41, 158, 0.5);
  margin-top: 1.5rem;
`;
